import {h, Component} from 'preact';
import {Link} from 'react-router-dom';
import Cookies from 'universal-cookie';
import Util from '../../services/util';
import SymantecVIPregister from './symantec-vip-register';
import SymantecVIPactivate from './symantec-vip-activate';
import SymantecVIPauth from './symantec-vip-auth';
import authContainer from "../tags/auth-container";

export class Symantec extends Component {
    constructor() {
        super();
        this.cookies = new Cookies();
        this.authMode = this.cookies.get('authenticationMode');
        this.state = {
            sectionClassName: 'auth-modal-container symantec-auth'
        }
    }

    componentDidMount() {
        document.title = 'Symantec VIP setup | workplace_';
        if (Util.isMobile()) {
            this.setState({ sectionClassName: 'mobile-symantec-auth' })
        }
    }

    renderSymantecForm = () => {
        switch (this.authMode) {
            case 'symantecVIPregister':
                return <SymantecVIPregister loginForSimpleAuth={this.props.loginForSimpleAuth}
                                            mfaRedirection={this.props.mfaRedirection}
                                            focusById={this.props.focusById}
                                            pollingTimer={this.props.pollingTimer}
                                            renderHelpLink={this.props.renderHelpLink}/>;
            case 'symantecVIPactivate':
                return <SymantecVIPactivate loginForSimpleAuth={this.props.loginForSimpleAuth}
                                            mfaRedirection={this.props.mfaRedirection}
                                            focusById={this.props.focusById}
                                            pollingTimer={this.props.pollingTimer}
                                            renderHelpLink={this.props.renderHelpLink}/>;
            case 'symantecVIP':
                return <SymantecVIPauth loginForSimpleAuth={this.props.loginForSimpleAuth}
                                        mfaRedirection={this.props.mfaRedirection}
                                        focusById={this.props.focusById}
                                        pollingTimer={this.props.pollingTimer}
                                        renderHelpLink={this.props.renderHelpLink}/>;
            default:
                return;
        }
    };

    render({loginPageHeaderUrl}, {sectionClassName}) {
        return (
            <section class={sectionClassName}>
                <Link to='/'>
                    <img src={loginPageHeaderUrl || 'img/blank-header-image.gif'} class='login-header-image' alt='login-bg'/>
                </Link>
                {this.renderSymantecForm()}
            </section>
        )
    }
}

export default authContainer(Symantec);



// WEBPACK FOOTER //
// ./src/scripts/views/two-factor/symantec.js